import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { ImageUtilService } from '../../shared/image-util-service/image-util.service';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

const DEFAULT_PROFILE_PIC = '/images/profile-default-image-123x123.png';

@Component({
  selector: 'lp2-profile-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<img
    [src]="profilePic | safeUrl"
    [class]="'rounded-circle ' + class"
    [height]="_height"
    [width]="_width"
  />`,
})
export class ProfileAvatarComponent implements OnInit {
  @Input() uuid?: string;
  @Input() class?: string;
  public _height?: number = 44;
  @Input() set height(value: number) {
    this._height = value;
    this.cdRef.detectChanges();
  }
  public _width?: number = 44;
  @Input() set width(value: number) {
    this._width = value;
    this.cdRef.detectChanges();
  }

  public profilePic: string = DEFAULT_PROFILE_PIC;

  constructor(private readonly cdRef: ChangeDetectorRef, private readonly imageUtilService: ImageUtilService) {}

  ngOnInit(): void {
    this.imageUtilService
      .getProfilePicByUuid(this.height, this.width, this.uuid)
      .pipe(catchError(() => of(DEFAULT_PROFILE_PIC)))
      .subscribe((imageUrl) => {
        this.profilePic = imageUrl || DEFAULT_PROFILE_PIC;
        this.cdRef.detectChanges();
      });
  }
}

@NgModule({
  imports: [CommonModule, SafeUrlPipeModule],
  declarations: [ProfileAvatarComponent],
  exports: [ProfileAvatarComponent],
})
export class ProfileAvatarModule {}



// WEBPACK FOOTER //
// ./ts/app/components/profile-avatar/profile-avatar.component.ts